import React from "react";
import FormularioMeta from "components/ahorro/FormularioMeta";
import Navbar from "components/generales/Navbar";
import { Outlet } from "react-router-dom";

import "components/generales/Styles.css";
import "components/ahorro/StylesAhorro.css";

const RegistrarMeta = () => {
  return (
    <>
      <Outlet />
      <Navbar />
      <section>
        <div className="imagenContenedor imagenAhorro"></div>
        <div className="contenidoContenedor">
          <div className="formularioContenedor">
            <h2>Registrar Meta de Ahorro</h2>
            <FormularioMeta />
          </div>
        </div>
      </section>
    </>
  );
};

export default RegistrarMeta;
